import Ajax from '../ajax';

const controller = 'invitationCode';
export default {
  list: (filter) => Ajax('get', controller, filter),
  get: (id, parameter) => Ajax('get', `${controller}/${id}`, parameter),
  add: (parameter) => Ajax('post', controller, parameter),
  edit: (id, parameter) => Ajax('put', `${controller}/${id}`, parameter),
  modifyStatus: (id, isEnabled) => Ajax('put', `${controller}/${id}/enable?enabled=${isEnabled}`),
};
